(function ($) {
  DJ.addBehavior('renameTextAreaCharsAmount', '.node-resource-modal-add-form .js-form-type-textfield .file-rename-textfield', {
    attach: function () {
      const inputEl = this;
      const label = $(inputEl).closest('.js-form-type-textfield').find('label')[0];
      const charsRemain = document.createElement('span');
      let limit = 30;


      /**
       * Create div to display the amount of chars left to input.
       * Place this div under the inputEl.
       */
      charsRemain.classList.add('textarea-chars-amount');
      charsRemain.textContent = ` (${limit} caractères)`;

      if (label) {
        label.appendChild(charsRemain);
      }

      /**
       * Count chars depending on the set limit.
       */
      const countCharacters = () => {
        let counter = 0;

        if (inputEl.value.length > limit) {
          inputEl.value = inputEl.value.substring(0, limit);
        } else {
          counter = (limit - (inputEl.value.length));
        }

        if (counter === 1) {
          charsRemain.textContent = ` (${counter} caractère)`;
        } else {
          charsRemain.textContent = ` (${counter} caractères)`;
        }
      };

      countCharacters();

      /**
       * Add event listeners to the inputEl with the count function.
       */
      inputEl.addEventListener('input', countCharacters);
    }
  });
})(jQuery);
